import React from 'react';
import Card from "../../../components/card";
import {FaPlus, FaTrash} from "react-icons/fa";
import Button from "../../../components/button";
import SelectComponent from "../../../components/select-component";
const SolutionsTable = ({items, actions, solutions, setState, state}) => {


    const handleSelectChange = (id, value, index) => {
        solutions[index][id] = value;

        setState({...state, solutions})
    }

    const addSolution = () => {
            solutions.push({
                item: "", action: "", id: ""
            })

            setState({...state, solutions})
        };
        const handleInputListRemove = (index) => {
        solutions.splice(index, 1);

        setState({...state, solutions})
    };

    return (<Card title="Soluções" wrapperClass="mt-5">
            <Button onClick={addSolution} target="primary" col="mb-4">
                <FaPlus/> Adicionar solução
            </Button>

            <table id="pend-table">
                <thead>
                <tr>
                    <th style={{width: "42.5%"}}>Item</th>
                    <th style={{width: "42.5%"}}>Ação</th>
                    <th style={{width: "5%"}}></th>
                </tr>
                </thead>
                <tbody>
                {
                    state.solutions.map((solution, index) => {
                    return (<tr key={index}>
                            <td>
                                <SelectComponent
                                    instanceId="item"
                                    options={items}
                                    value={solution.item}
                                    onChange={(value) => handleSelectChange("item", value, index)}
                                />
                            </td>
                            <td>
                                <SelectComponent
                                    instanceId="action"
                                    options={actions}
                                    value={solution.action}
                                    onChange={(value) => handleSelectChange("action", value, index)}
                                />
                            </td>
                            <td style={{height: "30px"}}>
                                <Button target="danger" onClick={() => handleInputListRemove(index)}>
                                    <FaTrash/>
                                </Button>
                            </td>
                        </tr>)
                })}
                </tbody>
            </table>
        </Card>);
};

export default SolutionsTable;